export default __webpack_public_path__ + "static/media/logostep4.77141aff.svg";